import { TourSummary as API } from '@src/api/types';
import { generateUser } from '@src/factories';
import { TourSummery as Data } from '@src/types';

const Factory = (api: API): Data => ({
  id: api.wpPostId.toString(),
  title: api.title,
  cover: {
    uri: api.imageUrl,
  },
  price: api.price,
  beginDate: api.beginDate,
  endDate: api.endDate,
  termIds: api.termIds,
  leaderId: api.leaderId,
  booking: api.bookingOption,
  duration: api.duration,
  operator: generateUser(api.operator),
  capacity: api.capacity,
  featured: api.featured,
  highlight: api.highlight,
  rate: api.rate,
});

export default Factory;
